import PresetApi from '@/api/preset'
import { DS_CHART_PALETTE_ID, arrangePresetColorPalettes } from '@/business-logic/ds-chart-palette'

const _state = {
  colorPalettes: [],
}

const mutations = {
  setColorPalettes(state, payload) {
    state.colorPalettes = payload
  },
}

const actions = {
  async getPresetColorPalettesAction({ state, commit, rootGetters }) {
    if (rootGetters['featureToggles/canUseDsChartPalette']) {
      if (state.colorPalettes.some((palette) => palette.id === DS_CHART_PALETTE_ID)) return state.colorPalettes
      const resp = await PresetApi.getPresetColorPalettesV2Including(DS_CHART_PALETTE_ID)
      commit('setColorPalettes', resp.body)
      return resp.body
    }
    if (state.colorPalettes.length) return state.colorPalettes
    const resp = await PresetApi.getPresetColorPalettesV2()
    const colorPalettes = resp.body
    commit('setColorPalettes', colorPalettes)
    return colorPalettes
  },
}

const _getters = {
  presetColorPalettes: (state, _, __, rootGetters) => {
    return arrangePresetColorPalettes(state.colorPalettes, rootGetters['featureToggles/canUseDsChartPalette'])
  },
}

// A list fetched while the flag was still off (or still in flight when it turned on) lacks the DS palette the pickers default to.
export const refetchOnDsChartPaletteFlagPlugin = (store) => {
  store.watch(
    (state, getters) => Boolean(
      getters['featureToggles/canUseDsChartPalette']
      && state.presetModule.colorPalettes.length
      && !state.presetModule.colorPalettes.some((palette) => palette.id === DS_CHART_PALETTE_ID),
    ),
    (needsDsPalette) => {
      if (needsDsPalette) store.dispatch('presetModule/getPresetColorPalettesAction')
    },
  )
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters: _getters,
  plugin: refetchOnDsChartPaletteFlagPlugin,
}
